// source: news-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.newsmanager.AlertDispatchStatus', null, global);
goog.exportSymbol('proto.newsmanager.AlertMode', null, global);
goog.exportSymbol('proto.newsmanager.AssetClass', null, global);
goog.exportSymbol('proto.newsmanager.CalendarEvent', null, global);
goog.exportSymbol('proto.newsmanager.CalendarEventAlert', null, global);
goog.exportSymbol('proto.newsmanager.CalendarEventListReply', null, global);
goog.exportSymbol('proto.newsmanager.CalendarEventListReq', null, global);
goog.exportSymbol('proto.newsmanager.CreateCalendarEventAlertReply', null, global);
goog.exportSymbol('proto.newsmanager.CreateCalendarEventAlertReq', null, global);
goog.exportSymbol('proto.newsmanager.DeleteCalendarEventAlertReply', null, global);
goog.exportSymbol('proto.newsmanager.DeleteCalendarEventAlertReq', null, global);
goog.exportSymbol('proto.newsmanager.ImpactLevel', null, global);
goog.exportSymbol('proto.newsmanager.ListMyAlertsReply', null, global);
goog.exportSymbol('proto.newsmanager.ListMyAlertsReq', null, global);
goog.exportSymbol('proto.newsmanager.MarketNews', null, global);
goog.exportSymbol('proto.newsmanager.MarketNewsListReply', null, global);
goog.exportSymbol('proto.newsmanager.MarketNewsListReq', null, global);
goog.exportSymbol('proto.newsmanager.MyAlertItem', null, global);
goog.exportSymbol('proto.newsmanager.NewsSortBy', null, global);
goog.exportSymbol('proto.newsmanager.NotificationChannel', null, global);
goog.exportSymbol('proto.newsmanager.SentimentLabel', null, global);
goog.exportSymbol('proto.newsmanager.ToggleNewsBookmarkReply', null, global);
goog.exportSymbol('proto.newsmanager.ToggleNewsBookmarkReq', null, global);
goog.exportSymbol('proto.newsmanager.UpdateCalendarEventAlertReply', null, global);
goog.exportSymbol('proto.newsmanager.UpdateCalendarEventAlertReq', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CalendarEventListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.CalendarEventListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CalendarEventListReq.displayName = 'proto.newsmanager.CalendarEventListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CalendarEventListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.CalendarEventListReply.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.CalendarEventListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CalendarEventListReply.displayName = 'proto.newsmanager.CalendarEventListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CalendarEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.CalendarEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CalendarEvent.displayName = 'proto.newsmanager.CalendarEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.MarketNewsListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.MarketNewsListReq.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.MarketNewsListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.MarketNewsListReq.displayName = 'proto.newsmanager.MarketNewsListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.MarketNewsListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.MarketNewsListReply.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.MarketNewsListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.MarketNewsListReply.displayName = 'proto.newsmanager.MarketNewsListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.MarketNews = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.MarketNews.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.MarketNews, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.MarketNews.displayName = 'proto.newsmanager.MarketNews';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.ToggleNewsBookmarkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.ToggleNewsBookmarkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.ToggleNewsBookmarkReq.displayName = 'proto.newsmanager.ToggleNewsBookmarkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.ToggleNewsBookmarkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.ToggleNewsBookmarkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.ToggleNewsBookmarkReply.displayName = 'proto.newsmanager.ToggleNewsBookmarkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CalendarEventAlert = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.CalendarEventAlert.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.CalendarEventAlert, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CalendarEventAlert.displayName = 'proto.newsmanager.CalendarEventAlert';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.MyAlertItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.MyAlertItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.MyAlertItem.displayName = 'proto.newsmanager.MyAlertItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CreateCalendarEventAlertReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.CreateCalendarEventAlertReq.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.CreateCalendarEventAlertReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CreateCalendarEventAlertReq.displayName = 'proto.newsmanager.CreateCalendarEventAlertReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.CreateCalendarEventAlertReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.CreateCalendarEventAlertReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.CreateCalendarEventAlertReply.displayName = 'proto.newsmanager.CreateCalendarEventAlertReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.ListMyAlertsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.ListMyAlertsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.ListMyAlertsReq.displayName = 'proto.newsmanager.ListMyAlertsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.ListMyAlertsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.ListMyAlertsReply.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.ListMyAlertsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.ListMyAlertsReply.displayName = 'proto.newsmanager.ListMyAlertsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.UpdateCalendarEventAlertReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.newsmanager.UpdateCalendarEventAlertReq.repeatedFields_, null);
};
goog.inherits(proto.newsmanager.UpdateCalendarEventAlertReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.UpdateCalendarEventAlertReq.displayName = 'proto.newsmanager.UpdateCalendarEventAlertReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.UpdateCalendarEventAlertReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.UpdateCalendarEventAlertReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.UpdateCalendarEventAlertReply.displayName = 'proto.newsmanager.UpdateCalendarEventAlertReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.DeleteCalendarEventAlertReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.DeleteCalendarEventAlertReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.DeleteCalendarEventAlertReq.displayName = 'proto.newsmanager.DeleteCalendarEventAlertReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.newsmanager.DeleteCalendarEventAlertReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.newsmanager.DeleteCalendarEventAlertReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.newsmanager.DeleteCalendarEventAlertReply.displayName = 'proto.newsmanager.DeleteCalendarEventAlertReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CalendarEventListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CalendarEventListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CalendarEventListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
region: jspb.Message.getFieldWithDefault(msg, 1, ""),
impact: jspb.Message.getFieldWithDefault(msg, 2, ""),
fromDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
toDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
query: jspb.Message.getFieldWithDefault(msg, 5, ""),
page: jspb.Message.getFieldWithDefault(msg, 6, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0),
userId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CalendarEventListReq}
 */
proto.newsmanager.CalendarEventListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CalendarEventListReq;
  return proto.newsmanager.CalendarEventListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CalendarEventListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CalendarEventListReq}
 */
proto.newsmanager.CalendarEventListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpact(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CalendarEventListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CalendarEventListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CalendarEventListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImpact();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFromDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string region = 1;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string impact = 2;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getImpact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setImpact = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string from_date = 3;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getFromDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setFromDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string to_date = 4;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getToDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setToDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string query = 5;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 page = 6;
 * @return {number}
 */
proto.newsmanager.CalendarEventListReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 page_size = 7;
 * @return {number}
 */
proto.newsmanager.CalendarEventListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string user_id = 8;
 * @return {string}
 */
proto.newsmanager.CalendarEventListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventListReq} returns this
 */
proto.newsmanager.CalendarEventListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.CalendarEventListReply.repeatedFields_ = [1,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CalendarEventListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CalendarEventListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CalendarEventListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
calenderEventsList: jspb.Message.toObjectList(msg.getCalenderEventsList(),
    proto.newsmanager.CalendarEvent.toObject, includeInstance),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0),
countriesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CalendarEventListReply}
 */
proto.newsmanager.CalendarEventListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CalendarEventListReply;
  return proto.newsmanager.CalendarEventListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CalendarEventListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CalendarEventListReply}
 */
proto.newsmanager.CalendarEventListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.CalendarEvent;
      reader.readMessage(value,proto.newsmanager.CalendarEvent.deserializeBinaryFromReader);
      msg.addCalenderEvents(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addCountries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CalendarEventListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CalendarEventListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CalendarEventListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalenderEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.newsmanager.CalendarEvent.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * repeated CalendarEvent calender_events = 1;
 * @return {!Array<!proto.newsmanager.CalendarEvent>}
 */
proto.newsmanager.CalendarEventListReply.prototype.getCalenderEventsList = function() {
  return /** @type{!Array<!proto.newsmanager.CalendarEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.newsmanager.CalendarEvent, 1));
};


/**
 * @param {!Array<!proto.newsmanager.CalendarEvent>} value
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
*/
proto.newsmanager.CalendarEventListReply.prototype.setCalenderEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.newsmanager.CalendarEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.CalendarEvent}
 */
proto.newsmanager.CalendarEventListReply.prototype.addCalenderEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.newsmanager.CalendarEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.clearCalenderEventsList = function() {
  return this.setCalenderEventsList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.newsmanager.CalendarEventListReply.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.newsmanager.CalendarEventListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.newsmanager.CalendarEventListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string countries = 5;
 * @return {!Array<string>}
 */
proto.newsmanager.CalendarEventListReply.prototype.getCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.setCountriesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.addCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.CalendarEventListReply} returns this
 */
proto.newsmanager.CalendarEventListReply.prototype.clearCountriesList = function() {
  return this.setCountriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CalendarEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CalendarEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CalendarEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
region: jspb.Message.getFieldWithDefault(msg, 3, ""),
currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
impact: jspb.Message.getFieldWithDefault(msg, 5, ""),
actual: jspb.Message.getFieldWithDefault(msg, 6, ""),
forcast: jspb.Message.getFieldWithDefault(msg, 7, ""),
previous: jspb.Message.getFieldWithDefault(msg, 8, ""),
date: jspb.Message.getFieldWithDefault(msg, 9, ""),
lastUpdate: jspb.Message.getFieldWithDefault(msg, 10, 0),
country: jspb.Message.getFieldWithDefault(msg, 11, ""),
eventTime: jspb.Message.getFieldWithDefault(msg, 12, ""),
alertSet: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
alertId: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CalendarEvent}
 */
proto.newsmanager.CalendarEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CalendarEvent;
  return proto.newsmanager.CalendarEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CalendarEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CalendarEvent}
 */
proto.newsmanager.CalendarEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpact(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setActual(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setForcast(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrevious(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastUpdate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventTime(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlertSet(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CalendarEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CalendarEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CalendarEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImpact();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getActual();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getForcast();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPrevious();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLastUpdate();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEventTime();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAlertSet();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getAlertId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.newsmanager.CalendarEvent.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string region = 3;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string impact = 5;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getImpact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setImpact = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string actual = 6;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getActual = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setActual = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string forcast = 7;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getForcast = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setForcast = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string previous = 8;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getPrevious = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setPrevious = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string date = 9;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 last_update = 10;
 * @return {number}
 */
proto.newsmanager.CalendarEvent.prototype.getLastUpdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setLastUpdate = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string country = 11;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string event_time = 12;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getEventTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setEventTime = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool alert_set = 13;
 * @return {boolean}
 */
proto.newsmanager.CalendarEvent.prototype.getAlertSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setAlertSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string alert_id = 14;
 * @return {string}
 */
proto.newsmanager.CalendarEvent.prototype.getAlertId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEvent} returns this
 */
proto.newsmanager.CalendarEvent.prototype.setAlertId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.MarketNewsListReq.repeatedFields_ = [3,4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.MarketNewsListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.MarketNewsListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.MarketNewsListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNewsListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
query: jspb.Message.getFieldWithDefault(msg, 2, ""),
sourcesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
countriesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
impact: jspb.Message.getFieldWithDefault(msg, 5, 0),
sentiment: jspb.Message.getFieldWithDefault(msg, 6, 0),
assetClassesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
bookmarkedOnly: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
fromDate: jspb.Message.getFieldWithDefault(msg, 9, ""),
toDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
page: jspb.Message.getFieldWithDefault(msg, 11, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 12, 0),
sortBy: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.MarketNewsListReq}
 */
proto.newsmanager.MarketNewsListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.MarketNewsListReq;
  return proto.newsmanager.MarketNewsListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.MarketNewsListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.MarketNewsListReq}
 */
proto.newsmanager.MarketNewsListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSources(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCountries(value);
      break;
    case 5:
      var value = /** @type {!proto.newsmanager.ImpactLevel} */ (reader.readEnum());
      msg.setImpact(value);
      break;
    case 6:
      var value = /** @type {!proto.newsmanager.SentimentLabel} */ (reader.readEnum());
      msg.setSentiment(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.newsmanager.AssetClass>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAssetClasses(values[i]);
      }
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookmarkedOnly(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromDate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setToDate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 13:
      var value = /** @type {!proto.newsmanager.NewsSortBy} */ (reader.readEnum());
      msg.setSortBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.MarketNewsListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.MarketNewsListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.MarketNewsListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNewsListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSentiment();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAssetClassesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getBookmarkedOnly();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getFromDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getToDate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getSortBy();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.newsmanager.MarketNewsListReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.newsmanager.MarketNewsListReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string sources = 3;
 * @return {!Array<string>}
 */
proto.newsmanager.MarketNewsListReq.prototype.getSourcesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setSourcesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.addSources = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};


/**
 * repeated string countries = 4;
 * @return {!Array<string>}
 */
proto.newsmanager.MarketNewsListReq.prototype.getCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setCountriesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.addCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.clearCountriesList = function() {
  return this.setCountriesList([]);
};


/**
 * optional ImpactLevel impact = 5;
 * @return {!proto.newsmanager.ImpactLevel}
 */
proto.newsmanager.MarketNewsListReq.prototype.getImpact = function() {
  return /** @type {!proto.newsmanager.ImpactLevel} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.newsmanager.ImpactLevel} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional SentimentLabel sentiment = 6;
 * @return {!proto.newsmanager.SentimentLabel}
 */
proto.newsmanager.MarketNewsListReq.prototype.getSentiment = function() {
  return /** @type {!proto.newsmanager.SentimentLabel} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.newsmanager.SentimentLabel} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setSentiment = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated AssetClass asset_classes = 7;
 * @return {!Array<!proto.newsmanager.AssetClass>}
 */
proto.newsmanager.MarketNewsListReq.prototype.getAssetClassesList = function() {
  return /** @type {!Array<!proto.newsmanager.AssetClass>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.newsmanager.AssetClass>} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setAssetClassesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.newsmanager.AssetClass} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.addAssetClasses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.clearAssetClassesList = function() {
  return this.setAssetClassesList([]);
};


/**
 * optional bool bookmarked_only = 8;
 * @return {boolean}
 */
proto.newsmanager.MarketNewsListReq.prototype.getBookmarkedOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setBookmarkedOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string from_date = 9;
 * @return {string}
 */
proto.newsmanager.MarketNewsListReq.prototype.getFromDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setFromDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string to_date = 10;
 * @return {string}
 */
proto.newsmanager.MarketNewsListReq.prototype.getToDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setToDate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 page = 11;
 * @return {number}
 */
proto.newsmanager.MarketNewsListReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 page_size = 12;
 * @return {number}
 */
proto.newsmanager.MarketNewsListReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional NewsSortBy sort_by = 13;
 * @return {!proto.newsmanager.NewsSortBy}
 */
proto.newsmanager.MarketNewsListReq.prototype.getSortBy = function() {
  return /** @type {!proto.newsmanager.NewsSortBy} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.newsmanager.NewsSortBy} value
 * @return {!proto.newsmanager.MarketNewsListReq} returns this
 */
proto.newsmanager.MarketNewsListReq.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.MarketNewsListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.MarketNewsListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.MarketNewsListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.MarketNewsListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNewsListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
newsList: jspb.Message.toObjectList(msg.getNewsList(),
    proto.newsmanager.MarketNews.toObject, includeInstance),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.MarketNewsListReply}
 */
proto.newsmanager.MarketNewsListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.MarketNewsListReply;
  return proto.newsmanager.MarketNewsListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.MarketNewsListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.MarketNewsListReply}
 */
proto.newsmanager.MarketNewsListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.MarketNews;
      reader.readMessage(value,proto.newsmanager.MarketNews.deserializeBinaryFromReader);
      msg.addNews(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.MarketNewsListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.MarketNewsListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.MarketNewsListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNewsListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.newsmanager.MarketNews.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated MarketNews news = 1;
 * @return {!Array<!proto.newsmanager.MarketNews>}
 */
proto.newsmanager.MarketNewsListReply.prototype.getNewsList = function() {
  return /** @type{!Array<!proto.newsmanager.MarketNews>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.newsmanager.MarketNews, 1));
};


/**
 * @param {!Array<!proto.newsmanager.MarketNews>} value
 * @return {!proto.newsmanager.MarketNewsListReply} returns this
*/
proto.newsmanager.MarketNewsListReply.prototype.setNewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.newsmanager.MarketNews=} opt_value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNews}
 */
proto.newsmanager.MarketNewsListReply.prototype.addNews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.newsmanager.MarketNews, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNewsListReply} returns this
 */
proto.newsmanager.MarketNewsListReply.prototype.clearNewsList = function() {
  return this.setNewsList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.newsmanager.MarketNewsListReply.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNewsListReply} returns this
 */
proto.newsmanager.MarketNewsListReply.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.newsmanager.MarketNewsListReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNewsListReply} returns this
 */
proto.newsmanager.MarketNewsListReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.newsmanager.MarketNewsListReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNewsListReply} returns this
 */
proto.newsmanager.MarketNewsListReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.MarketNews.repeatedFields_ = [13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.MarketNews.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.MarketNews.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.MarketNews} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNews.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
summary: jspb.Message.getFieldWithDefault(msg, 3, ""),
body: jspb.Message.getFieldWithDefault(msg, 4, ""),
source: jspb.Message.getFieldWithDefault(msg, 5, ""),
sourceUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
impact: jspb.Message.getFieldWithDefault(msg, 8, 0),
sentiment: jspb.Message.getFieldWithDefault(msg, 9, 0),
sentimentScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
region: jspb.Message.getFieldWithDefault(msg, 11, ""),
country: jspb.Message.getFieldWithDefault(msg, 12, ""),
tickersList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
assetClassesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
publishedAt: jspb.Message.getFieldWithDefault(msg, 15, 0),
ingestedAt: jspb.Message.getFieldWithDefault(msg, 16, 0),
bookmarked: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.MarketNews}
 */
proto.newsmanager.MarketNews.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.MarketNews;
  return proto.newsmanager.MarketNews.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.MarketNews} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.MarketNews}
 */
proto.newsmanager.MarketNews.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceUrl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 8:
      var value = /** @type {!proto.newsmanager.ImpactLevel} */ (reader.readEnum());
      msg.setImpact(value);
      break;
    case 9:
      var value = /** @type {!proto.newsmanager.SentimentLabel} */ (reader.readEnum());
      msg.setSentiment(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSentimentScore(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    case 14:
      var values = /** @type {!Array<!proto.newsmanager.AssetClass>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAssetClasses(values[i]);
      }
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublishedAt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIngestedAt(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookmarked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.MarketNews.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.MarketNews.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.MarketNews} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MarketNews.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSourceUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSentiment();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSentimentScore();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getAssetClassesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      14,
      f
    );
  }
  f = message.getPublishedAt();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getIngestedAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getBookmarked();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string summary = 3;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string source = 5;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string source_url = 6;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getSourceUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setSourceUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string image_url = 7;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional ImpactLevel impact = 8;
 * @return {!proto.newsmanager.ImpactLevel}
 */
proto.newsmanager.MarketNews.prototype.getImpact = function() {
  return /** @type {!proto.newsmanager.ImpactLevel} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.newsmanager.ImpactLevel} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional SentimentLabel sentiment = 9;
 * @return {!proto.newsmanager.SentimentLabel}
 */
proto.newsmanager.MarketNews.prototype.getSentiment = function() {
  return /** @type {!proto.newsmanager.SentimentLabel} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.newsmanager.SentimentLabel} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setSentiment = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional double sentiment_score = 10;
 * @return {number}
 */
proto.newsmanager.MarketNews.prototype.getSentimentScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setSentimentScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional string region = 11;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string country = 12;
 * @return {string}
 */
proto.newsmanager.MarketNews.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string tickers = 13;
 * @return {!Array<string>}
 */
proto.newsmanager.MarketNews.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};


/**
 * repeated AssetClass asset_classes = 14;
 * @return {!Array<!proto.newsmanager.AssetClass>}
 */
proto.newsmanager.MarketNews.prototype.getAssetClassesList = function() {
  return /** @type {!Array<!proto.newsmanager.AssetClass>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<!proto.newsmanager.AssetClass>} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setAssetClassesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {!proto.newsmanager.AssetClass} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.addAssetClasses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.clearAssetClassesList = function() {
  return this.setAssetClassesList([]);
};


/**
 * optional int64 published_at = 15;
 * @return {number}
 */
proto.newsmanager.MarketNews.prototype.getPublishedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setPublishedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 ingested_at = 16;
 * @return {number}
 */
proto.newsmanager.MarketNews.prototype.getIngestedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setIngestedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional bool bookmarked = 17;
 * @return {boolean}
 */
proto.newsmanager.MarketNews.prototype.getBookmarked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.MarketNews} returns this
 */
proto.newsmanager.MarketNews.prototype.setBookmarked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.ToggleNewsBookmarkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.ToggleNewsBookmarkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ToggleNewsBookmarkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
newsId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
bookmarked: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.ToggleNewsBookmarkReq}
 */
proto.newsmanager.ToggleNewsBookmarkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.ToggleNewsBookmarkReq;
  return proto.newsmanager.ToggleNewsBookmarkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.ToggleNewsBookmarkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.ToggleNewsBookmarkReq}
 */
proto.newsmanager.ToggleNewsBookmarkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewsId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookmarked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.ToggleNewsBookmarkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.ToggleNewsBookmarkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ToggleNewsBookmarkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewsId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBookmarked();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string news_id = 1;
 * @return {string}
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.getNewsId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.ToggleNewsBookmarkReq} returns this
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.setNewsId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.ToggleNewsBookmarkReq} returns this
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool bookmarked = 3;
 * @return {boolean}
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.getBookmarked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.ToggleNewsBookmarkReq} returns this
 */
proto.newsmanager.ToggleNewsBookmarkReq.prototype.setBookmarked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.ToggleNewsBookmarkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.ToggleNewsBookmarkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ToggleNewsBookmarkReply.toObject = function(includeInstance, msg) {
  var f, obj = {
newsId: jspb.Message.getFieldWithDefault(msg, 1, ""),
bookmarked: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.ToggleNewsBookmarkReply}
 */
proto.newsmanager.ToggleNewsBookmarkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.ToggleNewsBookmarkReply;
  return proto.newsmanager.ToggleNewsBookmarkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.ToggleNewsBookmarkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.ToggleNewsBookmarkReply}
 */
proto.newsmanager.ToggleNewsBookmarkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewsId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBookmarked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.ToggleNewsBookmarkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.ToggleNewsBookmarkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ToggleNewsBookmarkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewsId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookmarked();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string news_id = 1;
 * @return {string}
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.getNewsId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.ToggleNewsBookmarkReply} returns this
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.setNewsId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool bookmarked = 2;
 * @return {boolean}
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.getBookmarked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.ToggleNewsBookmarkReply} returns this
 */
proto.newsmanager.ToggleNewsBookmarkReply.prototype.setBookmarked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.CalendarEventAlert.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CalendarEventAlert.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CalendarEventAlert.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CalendarEventAlert} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventAlert.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventName: jspb.Message.getFieldWithDefault(msg, 3, ""),
country: jspb.Message.getFieldWithDefault(msg, 4, ""),
channelsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
mode: jspb.Message.getFieldWithDefault(msg, 6, 0),
leadMinutes: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CalendarEventAlert}
 */
proto.newsmanager.CalendarEventAlert.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CalendarEventAlert;
  return proto.newsmanager.CalendarEventAlert.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CalendarEventAlert} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CalendarEventAlert}
 */
proto.newsmanager.CalendarEventAlert.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addChannels(values[i]);
      }
      break;
    case 6:
      var value = /** @type {!proto.newsmanager.AlertMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeadMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CalendarEventAlert.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CalendarEventAlert.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CalendarEventAlert} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CalendarEventAlert.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getLeadMinutes();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.newsmanager.CalendarEventAlert.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.newsmanager.CalendarEventAlert.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event_name = 3;
 * @return {string}
 */
proto.newsmanager.CalendarEventAlert.prototype.getEventName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setEventName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string country = 4;
 * @return {string}
 */
proto.newsmanager.CalendarEventAlert.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated NotificationChannel channels = 5;
 * @return {!Array<!proto.newsmanager.NotificationChannel>}
 */
proto.newsmanager.CalendarEventAlert.prototype.getChannelsList = function() {
  return /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.newsmanager.NotificationChannel>} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.newsmanager.NotificationChannel} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};


/**
 * optional AlertMode mode = 6;
 * @return {!proto.newsmanager.AlertMode}
 */
proto.newsmanager.CalendarEventAlert.prototype.getMode = function() {
  return /** @type {!proto.newsmanager.AlertMode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.newsmanager.AlertMode} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 lead_minutes = 7;
 * @return {number}
 */
proto.newsmanager.CalendarEventAlert.prototype.getLeadMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CalendarEventAlert} returns this
 */
proto.newsmanager.CalendarEventAlert.prototype.setLeadMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.MyAlertItem.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.MyAlertItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.MyAlertItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MyAlertItem.toObject = function(includeInstance, msg) {
  var f, obj = {
alert: (f = msg.getAlert()) && proto.newsmanager.CalendarEventAlert.toObject(includeInstance, f),
scheduledFor: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
event: (f = msg.getEvent()) && proto.newsmanager.CalendarEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.MyAlertItem}
 */
proto.newsmanager.MyAlertItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.MyAlertItem;
  return proto.newsmanager.MyAlertItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.MyAlertItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.MyAlertItem}
 */
proto.newsmanager.MyAlertItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.CalendarEventAlert;
      reader.readMessage(value,proto.newsmanager.CalendarEventAlert.deserializeBinaryFromReader);
      msg.setAlert(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setScheduledFor(value);
      break;
    case 3:
      var value = /** @type {!proto.newsmanager.AlertDispatchStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.newsmanager.CalendarEvent;
      reader.readMessage(value,proto.newsmanager.CalendarEvent.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.MyAlertItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.MyAlertItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.MyAlertItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.MyAlertItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlert();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.newsmanager.CalendarEventAlert.serializeBinaryToWriter
    );
  }
  f = message.getScheduledFor();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.newsmanager.CalendarEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional CalendarEventAlert alert = 1;
 * @return {?proto.newsmanager.CalendarEventAlert}
 */
proto.newsmanager.MyAlertItem.prototype.getAlert = function() {
  return /** @type{?proto.newsmanager.CalendarEventAlert} */ (
    jspb.Message.getWrapperField(this, proto.newsmanager.CalendarEventAlert, 1));
};


/**
 * @param {?proto.newsmanager.CalendarEventAlert|undefined} value
 * @return {!proto.newsmanager.MyAlertItem} returns this
*/
proto.newsmanager.MyAlertItem.prototype.setAlert = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.newsmanager.MyAlertItem} returns this
 */
proto.newsmanager.MyAlertItem.prototype.clearAlert = function() {
  return this.setAlert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.newsmanager.MyAlertItem.prototype.hasAlert = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 scheduled_for = 2;
 * @return {number}
 */
proto.newsmanager.MyAlertItem.prototype.getScheduledFor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.MyAlertItem} returns this
 */
proto.newsmanager.MyAlertItem.prototype.setScheduledFor = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional AlertDispatchStatus status = 3;
 * @return {!proto.newsmanager.AlertDispatchStatus}
 */
proto.newsmanager.MyAlertItem.prototype.getStatus = function() {
  return /** @type {!proto.newsmanager.AlertDispatchStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.newsmanager.AlertDispatchStatus} value
 * @return {!proto.newsmanager.MyAlertItem} returns this
 */
proto.newsmanager.MyAlertItem.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional CalendarEvent event = 4;
 * @return {?proto.newsmanager.CalendarEvent}
 */
proto.newsmanager.MyAlertItem.prototype.getEvent = function() {
  return /** @type{?proto.newsmanager.CalendarEvent} */ (
    jspb.Message.getWrapperField(this, proto.newsmanager.CalendarEvent, 4));
};


/**
 * @param {?proto.newsmanager.CalendarEvent|undefined} value
 * @return {!proto.newsmanager.MyAlertItem} returns this
*/
proto.newsmanager.MyAlertItem.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.newsmanager.MyAlertItem} returns this
 */
proto.newsmanager.MyAlertItem.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.newsmanager.MyAlertItem.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.CreateCalendarEventAlertReq.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CreateCalendarEventAlertReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CreateCalendarEventAlertReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CreateCalendarEventAlertReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
eventName: jspb.Message.getFieldWithDefault(msg, 3, ""),
country: jspb.Message.getFieldWithDefault(msg, 4, ""),
channelsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
mode: jspb.Message.getFieldWithDefault(msg, 6, 0),
leadMinutes: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq}
 */
proto.newsmanager.CreateCalendarEventAlertReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CreateCalendarEventAlertReq;
  return proto.newsmanager.CreateCalendarEventAlertReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CreateCalendarEventAlertReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq}
 */
proto.newsmanager.CreateCalendarEventAlertReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addChannels(values[i]);
      }
      break;
    case 6:
      var value = /** @type {!proto.newsmanager.AlertMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeadMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CreateCalendarEventAlertReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CreateCalendarEventAlertReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CreateCalendarEventAlertReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEventName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getLeadMinutes();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string event_name = 3;
 * @return {string}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getEventName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setEventName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string country = 4;
 * @return {string}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated NotificationChannel channels = 5;
 * @return {!Array<!proto.newsmanager.NotificationChannel>}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getChannelsList = function() {
  return /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.newsmanager.NotificationChannel>} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.newsmanager.NotificationChannel} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};


/**
 * optional AlertMode mode = 6;
 * @return {!proto.newsmanager.AlertMode}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getMode = function() {
  return /** @type {!proto.newsmanager.AlertMode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.newsmanager.AlertMode} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 lead_minutes = 7;
 * @return {number}
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.getLeadMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReq} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReq.prototype.setLeadMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.CreateCalendarEventAlertReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.CreateCalendarEventAlertReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.CreateCalendarEventAlertReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CreateCalendarEventAlertReply.toObject = function(includeInstance, msg) {
  var f, obj = {
alert: (f = msg.getAlert()) && proto.newsmanager.CalendarEventAlert.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReply}
 */
proto.newsmanager.CreateCalendarEventAlertReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.CreateCalendarEventAlertReply;
  return proto.newsmanager.CreateCalendarEventAlertReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.CreateCalendarEventAlertReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReply}
 */
proto.newsmanager.CreateCalendarEventAlertReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.CalendarEventAlert;
      reader.readMessage(value,proto.newsmanager.CalendarEventAlert.deserializeBinaryFromReader);
      msg.setAlert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.CreateCalendarEventAlertReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.CreateCalendarEventAlertReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.CreateCalendarEventAlertReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.CreateCalendarEventAlertReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlert();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.newsmanager.CalendarEventAlert.serializeBinaryToWriter
    );
  }
};


/**
 * optional CalendarEventAlert alert = 1;
 * @return {?proto.newsmanager.CalendarEventAlert}
 */
proto.newsmanager.CreateCalendarEventAlertReply.prototype.getAlert = function() {
  return /** @type{?proto.newsmanager.CalendarEventAlert} */ (
    jspb.Message.getWrapperField(this, proto.newsmanager.CalendarEventAlert, 1));
};


/**
 * @param {?proto.newsmanager.CalendarEventAlert|undefined} value
 * @return {!proto.newsmanager.CreateCalendarEventAlertReply} returns this
*/
proto.newsmanager.CreateCalendarEventAlertReply.prototype.setAlert = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.newsmanager.CreateCalendarEventAlertReply} returns this
 */
proto.newsmanager.CreateCalendarEventAlertReply.prototype.clearAlert = function() {
  return this.setAlert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.newsmanager.CreateCalendarEventAlertReply.prototype.hasAlert = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.ListMyAlertsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.ListMyAlertsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.ListMyAlertsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ListMyAlertsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fromTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
toTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
onlyUnmuted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
page: jspb.Message.getFieldWithDefault(msg, 5, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.ListMyAlertsReq}
 */
proto.newsmanager.ListMyAlertsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.ListMyAlertsReq;
  return proto.newsmanager.ListMyAlertsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.ListMyAlertsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.ListMyAlertsReq}
 */
proto.newsmanager.ListMyAlertsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFromTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setToTime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlyUnmuted(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.ListMyAlertsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.ListMyAlertsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.ListMyAlertsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ListMyAlertsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFromTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getToTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOnlyUnmuted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 from_time = 2;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getFromTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setFromTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 to_time = 3;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getToTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setToTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool only_unmuted = 4;
 * @return {boolean}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getOnlyUnmuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setOnlyUnmuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 page = 5;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 page_size = 6;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReq} returns this
 */
proto.newsmanager.ListMyAlertsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.ListMyAlertsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.ListMyAlertsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.ListMyAlertsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.ListMyAlertsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ListMyAlertsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.newsmanager.MyAlertItem.toObject, includeInstance),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.ListMyAlertsReply}
 */
proto.newsmanager.ListMyAlertsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.ListMyAlertsReply;
  return proto.newsmanager.ListMyAlertsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.ListMyAlertsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.ListMyAlertsReply}
 */
proto.newsmanager.ListMyAlertsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.MyAlertItem;
      reader.readMessage(value,proto.newsmanager.MyAlertItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.ListMyAlertsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.ListMyAlertsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.ListMyAlertsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.ListMyAlertsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.newsmanager.MyAlertItem.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated MyAlertItem items = 1;
 * @return {!Array<!proto.newsmanager.MyAlertItem>}
 */
proto.newsmanager.ListMyAlertsReply.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.newsmanager.MyAlertItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.newsmanager.MyAlertItem, 1));
};


/**
 * @param {!Array<!proto.newsmanager.MyAlertItem>} value
 * @return {!proto.newsmanager.ListMyAlertsReply} returns this
*/
proto.newsmanager.ListMyAlertsReply.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.newsmanager.MyAlertItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.MyAlertItem}
 */
proto.newsmanager.ListMyAlertsReply.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.newsmanager.MyAlertItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.ListMyAlertsReply} returns this
 */
proto.newsmanager.ListMyAlertsReply.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReply.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReply} returns this
 */
proto.newsmanager.ListMyAlertsReply.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReply} returns this
 */
proto.newsmanager.ListMyAlertsReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.newsmanager.ListMyAlertsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.ListMyAlertsReply} returns this
 */
proto.newsmanager.ListMyAlertsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.newsmanager.UpdateCalendarEventAlertReq.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.UpdateCalendarEventAlertReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.UpdateCalendarEventAlertReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
alertId: jspb.Message.getFieldWithDefault(msg, 2, ""),
setMuted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
isMuted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
setChannels: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
channelsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
setLeadMinutes: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
leadMinutes: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.UpdateCalendarEventAlertReq;
  return proto.newsmanager.UpdateCalendarEventAlertReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetMuted(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMuted(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetChannels(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addChannels(values[i]);
      }
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetLeadMinutes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeadMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.UpdateCalendarEventAlertReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.UpdateCalendarEventAlertReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAlertId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSetMuted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsMuted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSetChannels();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getSetLeadMinutes();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLeadMinutes();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string alert_id = 2;
 * @return {string}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getAlertId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setAlertId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool set_muted = 3;
 * @return {boolean}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getSetMuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setSetMuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_muted = 4;
 * @return {boolean}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getIsMuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setIsMuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool set_channels = 5;
 * @return {boolean}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getSetChannels = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setSetChannels = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated NotificationChannel channels = 6;
 * @return {!Array<!proto.newsmanager.NotificationChannel>}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getChannelsList = function() {
  return /** @type {!Array<!proto.newsmanager.NotificationChannel>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.newsmanager.NotificationChannel>} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.newsmanager.NotificationChannel} value
 * @param {number=} opt_index
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};


/**
 * optional bool set_lead_minutes = 7;
 * @return {boolean}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getSetLeadMinutes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setSetLeadMinutes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 lead_minutes = 8;
 * @return {number}
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.getLeadMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReq} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReq.prototype.setLeadMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.UpdateCalendarEventAlertReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.UpdateCalendarEventAlertReply.toObject = function(includeInstance, msg) {
  var f, obj = {
alert: (f = msg.getAlert()) && proto.newsmanager.CalendarEventAlert.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReply}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.UpdateCalendarEventAlertReply;
  return proto.newsmanager.UpdateCalendarEventAlertReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReply}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.newsmanager.CalendarEventAlert;
      reader.readMessage(value,proto.newsmanager.CalendarEventAlert.deserializeBinaryFromReader);
      msg.setAlert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.UpdateCalendarEventAlertReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.UpdateCalendarEventAlertReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.UpdateCalendarEventAlertReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlert();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.newsmanager.CalendarEventAlert.serializeBinaryToWriter
    );
  }
};


/**
 * optional CalendarEventAlert alert = 1;
 * @return {?proto.newsmanager.CalendarEventAlert}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.getAlert = function() {
  return /** @type{?proto.newsmanager.CalendarEventAlert} */ (
    jspb.Message.getWrapperField(this, proto.newsmanager.CalendarEventAlert, 1));
};


/**
 * @param {?proto.newsmanager.CalendarEventAlert|undefined} value
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReply} returns this
*/
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.setAlert = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.newsmanager.UpdateCalendarEventAlertReply} returns this
 */
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.clearAlert = function() {
  return this.setAlert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.newsmanager.UpdateCalendarEventAlertReply.prototype.hasAlert = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.DeleteCalendarEventAlertReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.DeleteCalendarEventAlertReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
alertId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReq}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.DeleteCalendarEventAlertReq;
  return proto.newsmanager.DeleteCalendarEventAlertReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReq}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.DeleteCalendarEventAlertReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.DeleteCalendarEventAlertReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAlertId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReq} returns this
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string alert_id = 2;
 * @return {string}
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.getAlertId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReq} returns this
 */
proto.newsmanager.DeleteCalendarEventAlertReq.prototype.setAlertId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.newsmanager.DeleteCalendarEventAlertReply.prototype.toObject = function(opt_includeInstance) {
  return proto.newsmanager.DeleteCalendarEventAlertReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.DeleteCalendarEventAlertReply.toObject = function(includeInstance, msg) {
  var f, obj = {
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReply}
 */
proto.newsmanager.DeleteCalendarEventAlertReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.newsmanager.DeleteCalendarEventAlertReply;
  return proto.newsmanager.DeleteCalendarEventAlertReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReply}
 */
proto.newsmanager.DeleteCalendarEventAlertReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.newsmanager.DeleteCalendarEventAlertReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.newsmanager.DeleteCalendarEventAlertReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.newsmanager.DeleteCalendarEventAlertReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.newsmanager.DeleteCalendarEventAlertReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool deleted = 1;
 * @return {boolean}
 */
proto.newsmanager.DeleteCalendarEventAlertReply.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.newsmanager.DeleteCalendarEventAlertReply} returns this
 */
proto.newsmanager.DeleteCalendarEventAlertReply.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.newsmanager.ImpactLevel = {
  IMPACT_LEVEL_UNSPECIFIED: 0,
  IMPACT_LEVEL_LOW: 1,
  IMPACT_LEVEL_MEDIUM: 2,
  IMPACT_LEVEL_HIGH: 3
};

/**
 * @enum {number}
 */
proto.newsmanager.SentimentLabel = {
  SENTIMENT_LABEL_UNSPECIFIED: 0,
  SENTIMENT_LABEL_BEARISH: 1,
  SENTIMENT_LABEL_SOMEWHAT_BEARISH: 2,
  SENTIMENT_LABEL_NEUTRAL: 3,
  SENTIMENT_LABEL_SOMEWHAT_BULLISH: 4,
  SENTIMENT_LABEL_BULLISH: 5
};

/**
 * @enum {number}
 */
proto.newsmanager.AssetClass = {
  ASSET_CLASS_UNSPECIFIED: 0,
  ASSET_CLASS_FOREX: 1,
  ASSET_CLASS_INDEX: 2,
  ASSET_CLASS_CRYPTO: 3,
  ASSET_CLASS_COMMODITY: 4,
  ASSET_CLASS_EQUITY: 5
};

/**
 * @enum {number}
 */
proto.newsmanager.NewsSortBy = {
  NEWS_SORT_BY_UNSPECIFIED: 0,
  NEWS_SORT_BY_PUBLISHED_AT_DESC: 1,
  NEWS_SORT_BY_IMPACT_DESC: 2,
  NEWS_SORT_BY_SENTIMENT_SCORE: 3
};

/**
 * @enum {number}
 */
proto.newsmanager.NotificationChannel = {
  NOTIFICATION_CHANNEL_UNSPECIFIED: 0,
  NOTIFICATION_CHANNEL_PUSH: 1,
  NOTIFICATION_CHANNEL_EMAIL: 2,
  NOTIFICATION_CHANNEL_SMS: 3,
  NOTIFICATION_CHANNEL_SLACK: 4,
  NOTIFICATION_CHANNEL_IN_APP: 5
};

/**
 * @enum {number}
 */
proto.newsmanager.AlertDispatchStatus = {
  ALERT_DISPATCH_STATUS_UNSPECIFIED: 0,
  ALERT_DISPATCH_STATUS_PENDING: 1,
  ALERT_DISPATCH_STATUS_QUEUED: 2,
  ALERT_DISPATCH_STATUS_SENT: 3,
  ALERT_DISPATCH_STATUS_FAILED: 4
};

/**
 * @enum {number}
 */
proto.newsmanager.AlertMode = {
  ALERT_MODE_UNSPECIFIED: 0,
  ALERT_MODE_ONCE: 1,
  ALERT_MODE_RECURRING: 2
};

goog.object.extend(exports, proto.newsmanager);
